import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d902ed6a&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d902ed6a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d902ed6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d902ed6a')) {
      api.createRecord('d902ed6a', component.options)
    } else {
      api.reload('d902ed6a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d902ed6a&scoped=true&lang=pug", function () {
      api.rerender('d902ed6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/renewalReminder/index.vue"
export default component.exports